import { render, staticRenderFns } from "./ExpendableTags.vue?vue&type=template&id=6321d3a8&"
import script from "./ExpendableTags.vue?vue&type=script&lang=js&"
export * from "./ExpendableTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports